// @flow
import * as React from 'react';

import Avatar from 'components/Avatar';

import type { AvatarSize } from 'components/Avatar';

type Props = {
  color?: ?'brand' | 'grey' | 'fullGrey' | 'white',
  size?: AvatarSize,
  className?: ?string,
};

export default class GroupChatAvatar extends React.PureComponent<Props> {
  render() {
    const { color, size, className } = this.props;

    return <Avatar color={color} size={size} className={className} glyphName="message-group" />;
  }
}
